<template>
  <Input
    class="u-input"
    :type="type"
    :value="value"
    :size="size"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :disabled="disabled"
    :icon="icon"
    :autosize="autosize"
    :rows="rows"
    :readonly="readonly"
    :name="name"
    :number="number"
    :autofocus="autofocus"
    :spellcheck="spellcheck"
    :autocomplete="autocomplete"
    :clearable="clearable"
    :element-id="elementId"
    :wrap="wrap"
    :prefix="prefix"
    :suffix="suffix"
    :search="search"
    :enter-button="enterButton"
    @input="input"
    @on-enter="onEnter"
    @on-click="onClick"
    @on-change="onChange"
    @on-focus="onFocus"
    @on-blur="onBlur"
    @on-keyup="onKeyup"
    @on-keydown="onkeydown"
    @on-keypress="onKeypress"
    @on-search="onSearch"
  >
    <slot name="prepend" slot="prepend"></slot><!--eslint-disable-line-->

    <slot name="append" slot="appent"></slot><!--eslint-disable-line-->

    <slot name="prefix" slot="prefix"></slot><!--eslint-disable-line-->

    <slot name="suffix" slot="suffix"></slot><!--eslint-disable-line-->
</Input> <!--eslint-disable-line-->
</template>

<script>
import "@/styles/component/uInput.less";
export default {
  name: "uInput",
  props: {
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxlength: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: String,
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    number: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    spellcheck: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    elementId: {
      type: String
    },
    wrap: {
      type: String,
      default: "soft"
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    search: {
      type: Boolean,
      default: false
    },
    enterButton: {
      type: [Boolean, String],
      default: false
    }
  },
  data() {
    return {
      value2: ""
    };
  },
  methods: {
    input(value) {
      this.$emit("input", value);
    },
    onEnter() {
      //按下回车键触发
      this.$emit("on-enter");
    },
    onClick() {
      //设置 icon 属性后，点击图标时触发
      this.$emit("on-click");
    },
    onChange(event) {
      //数据改变时触发
      this.$emit("on-change", event);
    },
    onFocus() {
      //输入框聚焦时触发
      this.$emit("on-focus");
    },
    onBlur() {
      //输入框失去焦点时触发
      this.$emit("on-blur");
    },
    onKeyup(event) {
      //原生的 keyup 事件
      this.$emit("on-keyup", event);
    },
    onkeydown(event) {
      //原生的 keydown 事件
      this.$emit("on-keydown", event);
    },
    onKeypress(event) {
      //原生的 keypress 事件
      this.$emit("on-keypress", event);
    },
    onSearch(value) {
      //开启 search 时可用，点击搜索或按下回车键时触发
      this.$emit("on-search", value);
    }
  }
};
</script>
